// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__VfCIf","header":"ReportDetails_header__273hu","title":"ReportDetails_title__gEErn","left":"ReportDetails_left__L9eeu"};